import { createId } from '@services/utils'

export const useLandingZoneMembership = () => {
    const formatMembership = (item) => {
        const data = {owners: [], members: [], channels: []}

        if (item.channels) {
            for (let i = 0; i < item.channels.length; i++) {
                const channel = item.channels[i]
                data.channels.push({
                    id: createId(),
                    name: channel.displayName ?? '-',
                    objectId: channel.objectId ?? '-',
                    mail: channel.email ?? '-',
                    link: channel.webUrl ?? null
                })
            }
        }

        if (item.owners) {
            for (let i = 0; i < item.owners.length; i++) {
                const owner = item.owners[i]
                data.owners.push({
                    id: createId(),
                    name: owner.displayName ?? '-',
                    type: owner.type ?? '-',
                    objectId: owner.id ?? '-',
                    mail: owner.mail ?? '-'
                })
            }
        }

        if (item.members) {
            for (let i = 0; i < item.members.length; i++) {
                const member = item.members[i]
                data.members.push({
                    id: createId(),
                    name: member.displayName ?? '-',
                    type: member.type ?? '-',
                    objectId: member.id ?? '-',
                    mail: member.mail ?? '-'
                })
            }
        }

        return data
    }

    return { formatMembership }
}